<header class="header">
  <nav class="nav">
    <ul class="nav-items mod-main">
      <li class="nav-item mod-logo">
        <a class="logo-link" [routerLink]="['/']"><img class="logo" src="api/config/branding/logo.png" /></a>
      </li>
      <ng-container *ngIf="user$ | async as user">
        <ng-container *ngIf="user.isAuthenticated">
          <li *ngFor="let item of menuItems" class="nav-item">
            <a class="nav-item-link" [routerLink]="item.matchUrl" [routerLinkActive]="'mod-active'">
              {{item.name | translate}}
            </a>
          </li>
        </ng-container>
      </ng-container>
    </ul>
  </nav>
  <section class="profile">
    <cp-language-selector *ngIf="locale$ | async as locale" class="language-selector branding-accent-normal-border"
                          [options]="languages" [selected]="locale"
                          (languageChange)="setLocale($event)">
    </cp-language-selector>
    <ng-container *ngIf="user$ | async as user">
      <ng-container *ngIf="user.isAuthenticated">
        <a class="profile-name branding-accent-color-foreground" [routerLink]="['/people', 'profile']">
          <span class="ellipsize">{{user.name}}</span>
        </a>
        <div class="logout">
          <a class="nav-item-logout branding-accent-normal-foreground" (click)="logout()">{{'Menu.logout' | translate}}</a>
        </div>
      </ng-container>
    </ng-container>
  </section>
</header>
<menu class="menu branding-accent-normal-background">
  <nav class="nav">
    <ng-container *ngIf="user$ | async as user">
      <ul *ngIf="user.isAuthenticated" class="nav-items">
        <ng-container *ngFor="let item of subMenuItems">
          <li *ngIf="!item.manager || user.isManager" class="subnav-item">
            <a class="subnav-item-link" [routerLink]="item.matchUrl" [routerLinkActive]="'mod-active'">
              {{item.name | translate}}
            </a>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </nav>
  <ng-container *ngIf="user$ | async as user">
    <section *ngIf="user.isAuthenticated" class="quick-actions">
      <a class="quick-action-link branding-accent-normal-foreground-hover" [routerLink]="['translation-jobs', 'quotes', 'new']">{{'Dashboard.startJob' | translate}}</a>
    </section>
  </ng-container>
</menu>
